import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Spritesheet, Texture } from "pixi.js";
export class SocialCommunitiesResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("SocialCommunitiesResourcePackage");
    }
    public get assets_views_social_communities_social_communities_0_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/social_communities/social_communities-0_1x.atlas.json");
    }
    public get assets_views_social_communities_glass_bg_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["glass_bg.png"];
    }
    public get assets_views_social_communities_lights_light_2_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["lights/light_2.png"];
    }
    public get assets_views_social_communities_lights_light_3_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["lights/light_3.png"];
    }
    public get assets_views_social_communities_lights_light_5_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["lights/light_5.png"];
    }
    public get assets_views_social_communities_lights_light_4_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["lights/light_4.png"];
    }
    public get assets_views_social_communities_logo_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["logo.png"];
    }
    public get assets_views_social_communities_line_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["line.png"];
    }
    public get assets_views_social_communities_bg_icons_instagram_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["bg_icons/instagram.png"];
    }
    public get assets_views_social_communities_bg_icons_diskord_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["bg_icons/diskord.png"];
    }
    public get assets_views_social_communities_menu_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["menu.png"];
    }
    public get assets_views_social_communities_bg_icons_twitter_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["bg_icons/twitter.png"];
    }
    public get assets_views_social_communities_bg_icons_facebook_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["bg_icons/facebook.png"];
    }
    public get assets_views_social_communities_bg_icons_tik_tok_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["bg_icons/tik_tok.png"];
    }
    public get assets_views_social_communities_bg_icons_twitter_blur_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["bg_icons/twitter_blur.png"];
    }
    public get assets_views_social_communities_icons_Instagram_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["icons/Instagram.png"];
    }
    public get assets_views_social_communities_icons_diskord_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["icons/diskord.png"];
    }
    public get assets_views_social_communities_icons_facebook_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["icons/facebook.png"];
    }
    public get assets_views_social_communities_icons_tik_tok_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["icons/tik_tok.png"];
    }
    public get assets_views_social_communities_icons_x_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["icons/x.png"];
    }
    public get assets_views_social_communities_bg_icons_instagram_blur_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["bg_icons/instagram_blur.png"];
    }
    public get assets_views_social_communities_bg_icons_facebook_blur_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["bg_icons/facebook_blur.png"];
    }
    public get assets_views_social_communities_bg_icons_crown_png(): Texture {
        return this.assets_views_social_communities_social_communities_0_1x_atlas_json.textures["bg_icons/crown.png"];
    }
    public get assets_views_social_communities_social_communities_0_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/social_communities/social_communities-0_1x.atlas.png");
    }
    public get assets_views_social_communities_social_communities_1_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/social_communities/social_communities-1_1x.atlas.json");
    }
    public get assets_views_social_communities_lights_light_1_png(): Texture {
        return this.assets_views_social_communities_social_communities_1_1x_atlas_json.textures["lights/light_1.png"];
    }
    public get assets_views_social_communities_social_communities_1_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/social_communities/social_communities-1_1x.atlas.png");
    }
}

